export const filterByValue = <T = unknown>(arr: Array<T>, value: string) => {
  return value === ''
    ? arr
    : arr.filter((data) => JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1);
};
